import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from '@angular/animations';

export const openClose = trigger('openClose', [
  state(
    'open',
    style({
      'max-height': '800px',
      'max-width': '1000px',
      opacity: 1,
    })
  ),
  state(
    'closed',
    style({
      'max-height': '0px',
      'max-width': '0px',
      opacity: 0,
    })
  ),
  transition('open => closed', [
    animate(
      '0.7s',
      keyframes([
        style({
          opacity: 1,
          'max-height': '800px',
          'max-width': '1000px',
          offset: 0,
        }),
        style({
          opacity: 0,
          'max-height': '800px',
          'max-width': '1000px',
          offset: 0.2,
        }),
        style({
          opacity: 0,
          'max-height': '0px',
          'max-width': '0px',
          offset: 0.7,
        }),
      ])
    ),
  ]),
  transition('closed => open', [
    animate(
      '0.7s',
      keyframes([
        style({
          opacity: 0,
          'max-height': '0px',
          'max-width': '0px',
          offset: 0,
        }),
        style({
          opacity: 1,
          'max-height': '800px',
          'max-width': '1000px',
          offset: 0.5,
        }),
        style({
          opacity: 1,
          'max-height': '800px',
          'max-width': '1000px',
          offset: 0.7,
        }),
      ])
    ),
  ]),
]);
